import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-store-profile-location-group",
  templateUrl: "./store-profile-location-group.component.html",
  styleUrls: ["./store-profile-location-group.component.scss"]
})
export class StoreProfileLocationGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
